import React, { useState } from 'react';
import './Dashboard.css';
import DocumentsReport from '../Reports/DocumentsReport';
import WorkReports from '../Reports/WorkReports';
import ExcelUpload from '../Reports/ExcelUpload';
import TenantsReport from '../Reports/TenantsReport';
import ContractScreen from '../Reports/ContractScreen';
import PaymentsReport from '../Reports/PaymentsReport';
import ProfitabilityReport from '../Reports/ProfitabilityReport';

const Dashboard = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');

  const menuItems = [
    { id: 'dashboard', label: 'דשבורד', icon: '📊' },
    { id: 'documents', label: 'מסמכים', icon: '📄' },
    { id: 'tenants', label: 'דיירים', icon: '👥' },
    { id: 'contract', label: 'חוזה', icon: '📑' },
    { id: 'payments', label: 'תשלומים', icon: '💰' },
    ...(user?.type === 'SU' ? [{ id: 'profitability', label: 'רווחיות', icon: '📈' }] : []),
    // { id: 'work-reports', label: 'דוחות עבודה', icon: '🔧' },
    { id: 'excel-upload', label: 'כתב כמויות', icon: '📤' }   
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <DashboardHome dashboard={user?.dashboard} onTabChange={setActiveTab} user={user} />;
      case 'documents':
        return <DocumentsReportComponent user={user} />;
      case 'tenants':
        return <TenantsReport user={user} />;
      case 'contract':
        return <ContractScreen user={user} />;
      // case 'orders':
      //   return <OrdersReport />;
      case 'payments':
        return <PaymentsReportComponent user={user} />;
      case 'profitability':
        // הצג רק אם המשתמש הוא סופר יוזר
        if (user?.type !== 'SU') {
          return <DashboardHome dashboard={user?.dashboard} onTabChange={setActiveTab} />;
        }
        return <ProfitabilityReportComponent user={user} />;
      case 'work-reports':
        return <WorkReportsComponent user={user} />;
      case 'excel-upload':
        return <ExcelUploadComponent user={user} />;
      default:
        return <DashboardHome dashboard={user?.dashboard} onTabChange={setActiveTab} />;
    }
  };

  return (
    <div className="dashboard-container">
      {/* Header */}
      <header className="dashboard-header">        
        <div className="header-section header-left">
          
          <a href="tel:089930666" className="contact-icon-link" title="התקשר">
            <img src="/img/IconPhone.png" alt="טלפון" className="contact-icon" title="טלפון" />
          </a>
          <a href="https://wa.me/97289930666" target="_blank" rel="noopener noreferrer" className="contact-icon-link" title="WhatsApp">
            <img src="/img/IconWhatsApp.png" alt="WhatsApp" className="contact-icon" title="WhatsApp" />
          </a>
          <span className="contact-phone">08-9930666</span>
        </div>    
        <div className="header-section header-title">
          <div className="portal-title">פורטל קבלנים</div>
        </div>
        <div className="header-section header-center">
          <h1>Trabelci</h1>
        </div>
        <div className="header-section header-right">
          <div className="portal-subtitle">שלום{user?.username ? `, ${user.username}` : ', קבלן בדיקות'}</div>
          <button onClick={onLogout} className="logout-button">
            התנתק
          </button>
        </div>
      </header>

      {/* Navigation */}
      <nav className="dashboard-nav">
        {menuItems.map(item => (
          <button
            key={item.id}
            className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            {/* <span className="nav-icon">{item.icon}</span> */}
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>

      {/* Main Content */}
      <main className="dashboard-content">
        {renderContent()}
      </main>
    </div>
  );
};

// קומפוננטת Dashboard דינמית
const DashboardHome = ({ dashboard, onTabChange, user }) => {
  if (!dashboard || !Array.isArray(dashboard)) {
    return (
      <div className="dashboard-home">
        <h2>ברוכים הבאים למערכת הניהול של טרבלסי</h2>
        <div style={{ textAlign: 'center', padding: '40px' }}>טוען...</div>
      </div>
    );
  }

  // מיפוי U_LinkTo ללשוניות
  const linkToTabMap = {
    1: 'documents',      // מסמכים
    2: 'tenants',        // דיירים
    3: 'contract',       // חוזה
    4: 'payments',       // תשלומים
    5: 'profitability',  // רווחיות
    // 6: 'work-reports',   // דוחות עבודה
    7: 'excel-upload'    // כתב כמויות
  };

  // פונקציה לטיפול בלחיצה על כרטיס
  const handleCardClick = (linkTo) => {
    if (linkTo && linkTo !== -1 && linkTo !== '-1' && linkTo !== '') {
      const tabId = linkToTabMap[linkTo];
      // בדוק אם זה לשונית ריווחיות - הצג רק לסופר יוזר
      if (tabId === 'profitability' && user?.type !== 'SU') {
        return; // אל תעבור ללשונית אם המשתמש אינו סופר יוזר
      }
      if (tabId && onTabChange) {
        onTabChange(tabId);
      }
    }
  };

  // פונקציה לקבלת צבע טקסט
  const getTextColor = (color) => {
    if (!color || color === '' || color === 'black' || color === 'Black' || color === 'BLACK') {
      return null; // לא לשנות צבע
    }
    return color;
  };

  return (
    <div className="dashboard-home">
      <h2>ברוכים הבאים למערכת הניהול של טרבלסי</h2>
      <div className="stats-grid">
        {dashboard.map((item, index) => {
          // אם יש U_QryResult - השתמש בו, אחרת השתמש ב-U_Value או ערך אחר
          let value = item.U_QryResult !== undefined ? item.U_QryResult : (item.U_Value || item.Value || 0);
          const title = item.U_Title || item.Title || '';
          const subtitle = item.U_Subtitle || item.Subtitle || '';
          const linkTo = item.U_LinkTo;
          const color = item.U_Color;
          
          // בדוק אם הכרטיס צריך להיות קישור
          const isClickable = linkTo && linkTo !== -1 && linkTo !== '-1' && linkTo !== '';
          
          // המר אובייקטים ל-string או number
          if (value && typeof value === 'object') {
            // אם זה אובייקט - נסה להמיר ל-string
            value = JSON.stringify(value);
          }
          
          // המר null/undefined ל-0
          if (value === null || value === undefined) {
            value = 0;
          }
          
          // פורמט מספרי אם זה מספר
          const formattedValue = typeof value === 'number' 
            ? (title.includes('תשלום') || title.includes('רווח') || title.includes('סכום')
                ? `₪${value.toLocaleString()}`
                : value.toLocaleString())
            : String(value);
          
          // קבל צבע טקסט
          const textColor = getTextColor(color);
          
          // סגנון לכרטיס
          const cardStyle = {
            cursor: isClickable ? 'pointer' : 'default',
            transition: isClickable ? 'all 0.3s ease' : 'none'
          };

          // סגנון לטקסט
          const textStyle = textColor ? { color: textColor } : {};
          
          return (
            <div 
              key={index} 
              className="stat-card"
              style={cardStyle}
              onClick={() => handleCardClick(linkTo)}
              onMouseEnter={(e) => {
                if (isClickable) {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.15)';
                }
              }}
              onMouseLeave={(e) => {
                if (isClickable) {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '';
                }
              }}
            >
              <h3 style={textStyle}>{title}</h3>
              <p className="stat-number" style={textStyle}>{formattedValue}</p>
              <p className="stat-label" style={textStyle}>{subtitle}</p>
            </div>
          );
        })}
        {/* כרטיס ריק אחרון אם יש מספר אי-זוגי */}
        {dashboard.length % 2 !== 0 && <div className="stat-card"></div>}
      </div>
    </div>
  );
};

const DocumentsReportComponent = ({ user }) => <DocumentsReport user={user} />;

const OrdersReport = () => (
  <div className="report-container">
    <h2>דוח הזמנות</h2>
    <p>כאן יוצג דוח ההזמנות...</p>
  </div>
);

const PaymentsReportComponent = ({ user }) => <PaymentsReport user={user} />;

const ProfitabilityReportComponent = ({ user }) => <ProfitabilityReport user={user} />;

const WorkReportsComponent = ({ user }) => <WorkReports user={user} />;

const ExcelUploadComponent = ({ user }) => <ExcelUpload user={user} />;

export default Dashboard; 